<template>
  <div class="vm-form">
    <table v-if="nodeId.includes('DealDepartment')" class="gridtable" style="width: 100%;" cellspacing="0">
      <el-row>
        <el-col 
            v-for="formItem in data" 
            :key="formItem.varName" 
            :span="8"
            style="height:50px;border:1px solid #ddd">
          <span v-if="formItem.varText=='处理方式' || specialApproval" class="item">
            {{formItem.varText}}
          </span>
          <span
              :span="5"
              style="height: 24px;padding-left: 4px;">
            <el-input
                v-if="formItem.varType==='STRING'"
                v-model.trim="formItem.varValue"
                style="width: 50%"
                size="mini"
                class="tag"
                clearable
                placeholder="请输入"/>
            <el-switch
                v-else-if="formItem.varType==='BOOLEAN' && specialApproval"
                size="mini"
                :value="formItem.varValue==='true'"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @input="formItem.varValue=arguments[0]+''"/>
            <el-date-picker
                v-else-if="formItem.varType==='DATE'"
                v-model="formItem.varValue"
                size="mini"
                style="width: 50%"
                value-format="yyyy-MM-dd"
                class="tag"
                placeholder="选择日期"
                type="date"/>
            <el-select
                v-else-if="formItem.varType==='STRING[]'"
                v-model="formItem.varValue"
                size="mini"
                style="width: 40%"
                class="tag"
                clearable
                placeholder="请选择">
              <el-option
                  v-for="item in (formItem.varDefaultValue.split(','))"
                  :key="item"
                  :label="item"
                  :value="item"
                  @click.native="dealType(item)"/>
            </el-select>
          </span>
        </el-col> 
      </el-row>  
    </table>
    <table v-else class="gridtable" style="width: 100%;" cellspacing="0">
      <tr v-for="formItem in data" :key="formItem.varName" style="width: 100%;">
        <td style="width: 10%; text-align: right; background-color: #D1E6F5;">{{formItem.varText}}</td>
        <td style="height: 24px;">
          <el-input
              v-if="formItem.varType==='STRING'"
              v-model.trim="formItem.varValue"
              style="width: 50%"
              size="mini"
              class="tag"
              clearable
              placeholder="请输入"/>
          <el-switch
              v-else-if="formItem.varType==='BOOLEAN'"
              size="mini"
              :value="formItem.varValue==='true'"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @input="formItem.varValue=arguments[0]+''"/>
          <el-date-picker
              v-else-if="formItem.varType==='DATE'"
              v-model="formItem.varValue"
              size="mini"
              style="width: 50%"
              value-format="yyyy-MM-dd"
              class="tag"
              placeholder="选择日期"
              type="date"/>
          <el-select
              v-else-if="formItem.varType==='STRING[]'"
              v-model="formItem.varValue"
              size="mini"
              style="width: 50%"
              class="tag"
              clearable
              placeholder="请选择">
            <el-option
                v-for="item in formItem.varDefaultValue.split(',')"
                :key="item"
                :label="item"
                :value="item"
                style="width: 50%"/>
          </el-select>
          <el-select
              v-else-if="formItem.varType==='INT'"
              v-model="formItem.varValue"
              size="mini"
              style="width: 40%"
              filterable
              class="tag"
              clearable
              placeholder="请选择">
            <el-option
                v-for="item in userList"
                :key="item.systemUserID"
                :label="item.employeeName"
                :value="item.systemUserID"/>
          </el-select>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      data: {
        type: Array,
        required: true,
      },
      nodeId: {
        type: String,
        required: true,
        default: "",
      },
    },
    data() {
      return {
        specialApproval: false,
        userList: [
          {systemUserID:"0",employeeName:"无"},
          {systemUserID:"4301",employeeName:"陈宏镇"},
          {systemUserID:"2499",employeeName:"陈志承"},
          {systemUserID:"2500",employeeName:"范明哲"},
          {systemUserID:"2506",employeeName:"何啸天"},
          {systemUserID:"3098",employeeName:"徐琳"},
          {systemUserID:"2582",employeeName:"周萌"},
          {systemUserID:"2489",employeeName:"朱品军"},
          {systemUserID:"3097",employeeName:"尹金松"},
          {systemUserID:"4296",employeeName:"曹维雪"},
          {systemUserID:"4302",employeeName:"冯思聪"},
          {systemUserID:"4297",employeeName:"韩建民"},
          {systemUserID:"4298",employeeName:"胡海粟"},
          {systemUserID:"4293",employeeName:"计海林"},
          {systemUserID:"4290",employeeName:"刘伟"},
          {systemUserID:"4291",employeeName:"张杰（北京）"},
          {systemUserID:"4289",employeeName:"张杰（上海）"},
          {systemUserID:"2573",employeeName:"袁建强"},
          {systemUserID:"2492",employeeName:"邓刚林"},
          {systemUserID:"2572",employeeName:"徐亮"},
          {systemUserID:"4303",employeeName:"张新华"},
          {systemUserID:"4300",employeeName:"章文龙"},
          {systemUserID:"2567",employeeName:"唐景明"},
          {systemUserID:"4304",employeeName:"汪钰"},
          {systemUserID:"4305",employeeName:"岳稚钧"},
          {systemUserID:"4286",employeeName:"刘小锋"},
          {systemUserID:"4302",employeeName:"冯思聪"},
          {systemUserID:"4287",employeeName:"张卫升"},
          {systemUserID:"4288",employeeName:"吴昌文"},
          {systemUserID:"4313",employeeName:"皮海明"},
          {systemUserID:"7079",employeeName:"麦宇键"},
        ],
      };
    },
    // created() {
    //   if (this.nodeId.includes("csApproveAppointment")) {
    //     this.getUserList();
    //   }
    // },
    methods: {
      getUserList() {
        this.$http
          .get("basic", "system/user/getUserList")
          .then(res => {
            this.userList = [];
          });
      },
      dealType(item) {
        console.log(item);
        console.log(this.data);
        if (item ==="特批") {
          this.specialApproval = true;
          this.data[1].varValue= "true";
          this.data[1].varDefaultValue= "true";
        }else {
          this.specialApproval = false;
          this.data[1].varValue= "false";
          this.data[1].varDefaultValue= "false";
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vm-form {
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size: 11px;
      color:#333333;
      border-width: 1px;
      border-color: #dddddd;
      border-collapse: collapse;
    }
    .item {
      display: inline-block;
      font-size: 14px;
      padding: 4px;
      background-color: #D1E6F5;
      line-height: 40px;
      height: 41px;
      width: 50%;
      text-align: right;
    }
  }
</style>
